/* eslint-disable */
/**
 * Brand Preview — temporary visual sandbox for logo placement options.
 * Mounted at `/brand-preview` (public route, no auth gate). Delete this
 * file + the route entry once a combo is picked and applied.
 *
 * Renders all 9 design options (3 surfaces × A/B/C) side-by-side on a
 * single dark-canvas page for easy A/B comparison.
 */


const ICON = '/brand/icon_mark.svg';
const PRIMARY = '/brand/primary_logo.svg';
const STACKED = '/brand/secondary_logo.svg';

// Frame primitive — a labeled card so each option has a clear footer
function Frame({ tag, name, recommended, children, w = 320, h = 110, bg = '#161618' }) {
  return (
    <div className="rounded-lg overflow-hidden border border-border bg-[#0F0F11]">
      <div className="px-3 py-1.5 flex items-center gap-2 text-[10px] uppercase tracking-widest text-muted-foreground border-b border-border bg-card">
        <span className="font-mono">{tag}</span>
        <span className="flex-1 text-muted-foreground truncate">{name}</span>
        {recommended && (
          <span className="text-[#4575A8] text-[9px] font-semibold tracking-widest">★ PICK</span>
        )}
      </div>
      <div className="relative" style={{ width: w, height: h, background: bg }}>
        {children}
      </div>
    </div>
  );
}

// ─── SIDEBAR PREVIEWS ────────────────────────────────────────────────
function SidebarA() {
  return (
    <div className="absolute inset-0 flex items-center gap-3 px-6">
      <img src={ICON} alt="Strata" style={{ height: 32, width: 'auto' }} />
      <span style={{
        fontFamily: 'Outfit, sans-serif', fontWeight: 700, fontSize: 11,
        color: '#F2F0EB', letterSpacing: '0.18em', textTransform: 'uppercase',
      }}>STRATA × FRAMEWORK</span>
    </div>
  );
}
function SidebarB() {
  return (
    <div className="absolute inset-0 flex items-center px-6">
      <img
        src={PRIMARY}
        alt="Strata × Framework"
        style={{
          height: 28, width: 'auto',
          filter: 'drop-shadow(0 0 12px rgba(97,136,196,0.35))',
        }}
      />
    </div>
  );
}
function SidebarC() {
  return (
    <div className="absolute inset-0 flex items-center px-4">
      <div className="flex items-center gap-3 p-2 rounded-lg border"
           style={{ background: 'rgba(31,42,68,0.25)', borderColor: 'rgba(97,136,196,0.25)' }}>
        <img src={ICON} alt="Strata" style={{ height: 24, width: 'auto' }} />
        <span style={{
          fontFamily: 'Outfit, sans-serif', fontWeight: 700, fontSize: 11,
          color: '#F2F0EB', letterSpacing: '0.18em', textTransform: 'uppercase',
        }}>STRATA × FRAMEWORK</span>
      </div>
    </div>
  );
}
// Collapsed sidebar versions (60px wide rail)
function CollapsedSide({ children }) {
  return (
    <Frame tag="" name="" w={60} h={110} bg="#161618">
      <div className="absolute inset-0 flex items-start justify-center pt-6">
        {children}
      </div>
    </Frame>
  );
}

// ─── BROWSER TAB PREVIEWS (mock browser chrome) ──────────────────────
function TabMock({ favicon, faviconBg = 'transparent', title }) {
  return (
    <div className="rounded-md overflow-hidden border border-border bg-[#0F0F11]">
      <div className="bg-[#1F1F22] px-2 pt-2 flex items-center gap-1">
        <div className="w-2 h-2 rounded-full bg-[#FF5F56]" />
        <div className="w-2 h-2 rounded-full bg-[#FFBD2E]" />
        <div className="w-2 h-2 rounded-full bg-[#27C93F]" />
        <div className="ml-3 flex items-center gap-2 px-3 py-1.5 rounded-t-md bg-card text-[11px] text-muted-foreground"
             style={{ minWidth: 280 }}>
          <span
            className="inline-flex items-center justify-center"
            style={{
              width: 16, height: 16, borderRadius: faviconBg === 'transparent' ? 0 : 3,
              background: faviconBg, padding: faviconBg === 'transparent' ? 0 : 2,
            }}
          >
            <img src={favicon} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
          </span>
          <span className="truncate flex-1">{title}</span>
          <span className="text-[#52525A]">×</span>
        </div>
      </div>
      <div className="h-12 bg-card" />
    </div>
  );
}

// ─── LOGIN SCREEN PREVIEWS ───────────────────────────────────────────
function GlassCard({ children, h = 360 }) {
  return (
    <div className="rounded-xl overflow-hidden border border-border"
         style={{ width: 360, height: h, background: '#161618',
                  backgroundImage: 'radial-gradient(ellipse at top, rgba(97,136,196,0.07), transparent 60%)' }}>
      {children}
    </div>
  );
}
function FormStub() {
  return (
    <div className="px-8 mt-6 space-y-3">
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Email</div>
      <div className="h-9 rounded bg-[#0F0F11] border border-border" />
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground mt-2">Password</div>
      <div className="h-9 rounded bg-[#0F0F11] border border-border" />
      <div className="h-9 rounded bg-[#4575A8] mt-3 flex items-center justify-center text-[12px] text-[#161618] font-semibold tracking-wide uppercase">
        Sign In
      </div>
    </div>
  );
}
function LoginA() {
  return (
    <GlassCard>
      <div className="relative pt-12 flex items-center justify-center">
        <div
          className="absolute"
          style={{
            top: 18, left: '50%', transform: 'translateX(-50%)',
            width: 130, height: 130, borderRadius: 999,
            background: 'rgba(97,136,196,0.18)', filter: 'blur(40px)', pointerEvents: 'none',
          }}
        />
        <img src={STACKED} alt="Strata × Framework" style={{ height: 120, width: 'auto', position: 'relative' }} />
      </div>
      <FormStub />
    </GlassCard>
  );
}
function LoginB() {
  return (
    <GlassCard>
      <div className="px-8 pt-8">
        <img src={PRIMARY} alt="Strata × Framework" style={{ height: 36, width: 'auto' }} />
      </div>
      <div className="px-8 mt-5 text-[11px] uppercase tracking-widest text-muted-foreground">Sign in to your workspace</div>
      <FormStub />
    </GlassCard>
  );
}
function LoginC() {
  return (
    <GlassCard>
      <div className="relative h-full">
        <img
          src={ICON}
          alt=""
          aria-hidden
          style={{
            position: 'absolute', top: '50%', left: '50%',
            transform: 'translate(-50%,-50%)',
            width: 240, height: 240, opacity: 0.06, pointerEvents: 'none',
          }}
        />
        <div className="relative pt-8 px-8">
          <div style={{
            fontFamily: 'Outfit, sans-serif', fontWeight: 700, fontSize: 14,
            color: '#F2F0EB', letterSpacing: '0.22em', textTransform: 'uppercase',
          }}>STRATA × FRAMEWORK</div>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground mt-1">Sign in to continue</div>
          <FormStub />
        </div>
      </div>
    </GlassCard>
  );
}

// ─── PAGE ────────────────────────────────────────────────────────────
export default function BrandPreviewPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0C] text-foreground py-10 px-12"
         style={{ fontFamily: 'Inter, sans-serif' }}>
      <header className="max-w-7xl mx-auto mb-10">
        <div style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 700,
                      letterSpacing: '0.18em', textTransform: 'uppercase',
                      fontSize: 11, color: '#71717A' }}>
          Brand Preview · 9 options
        </div>
        <h1 className="text-3xl font-bold mt-1">Logo placement — pick a combo</h1>
        <p className="text-sm text-muted-foreground mt-2 max-w-3xl leading-relaxed">
          Three surfaces, three options each. ★ PICK is the design-agent's recommendation.
          Reply with your picks (e.g. "Sidebar A, Tab C, Login A") and I'll wire it in.
        </p>
      </header>

      <main className="max-w-7xl mx-auto space-y-12">
        {/* SIDEBAR */}
        <section>
          <h2 className="text-base font-semibold mb-3 flex items-center gap-2">
            <span className="text-[#4575A8] font-mono text-[10px] tracking-widest">01</span> Sidebar (expanded · 320px wide)
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Frame tag="A" name="Swiss Monogram (HTML text)" recommended><SidebarA /></Frame>
            <Frame tag="B" name="Precision Lockup (PNG + glow)"><SidebarB /></Frame>
            <Frame tag="C" name="Structural Badge"><SidebarC /></Frame>
          </div>
          <h2 className="text-base font-semibold mt-8 mb-3 flex items-center gap-2">
            <span className="text-[#4575A8] font-mono text-[10px] tracking-widest">01b</span> Sidebar (collapsed · 60px rail)
          </h2>
          <div className="flex gap-4 flex-wrap">
            <CollapsedSide><img src={ICON} alt="" style={{ height: 32 }} /></CollapsedSide>
            <CollapsedSide><img src={ICON} alt="" style={{ height: 28, filter: 'drop-shadow(0 0 12px rgba(97,136,196,0.35))' }} /></CollapsedSide>
            <CollapsedSide>
              <div className="p-2 rounded-lg border" style={{ background: 'rgba(31,42,68,0.25)', borderColor: 'rgba(97,136,196,0.25)' }}>
                <img src={ICON} alt="" style={{ height: 24 }} />
              </div>
            </CollapsedSide>
          </div>
        </section>

        {/* BROWSER TAB */}
        <section>
          <h2 className="text-base font-semibold mb-3 flex items-center gap-2">
            <span className="text-[#4575A8] font-mono text-[10px] tracking-widest">02</span> Browser tab / favicon
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <TabMock favicon={ICON} title="Strata × Framework" />
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground mt-2">A — Absolute Mark</div>
              <div className="text-[11px] text-muted-foreground mt-0.5">Strata X always. No tenant override.</div>
            </div>
            <div>
              <TabMock favicon={ICON} faviconBg="#F2F0EB" title="Strata × Framework" />
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground mt-2">B — Padded Light Mark</div>
              <div className="text-[11px] text-muted-foreground mt-0.5">Soft white pill behind the X for max contrast.</div>
            </div>
            <div>
              <TabMock favicon={ICON} title="Acme Landscaping | Strata × Framework" />
              <div className="text-[10px] uppercase tracking-widest text-[#4575A8] mt-2 flex items-center gap-1">
                ★ PICK · C — Dynamic Title Pairing
              </div>
              <div className="text-[11px] text-muted-foreground mt-0.5">Strata favicon, tenant name lives in the title text.</div>
            </div>
          </div>
        </section>

        {/* LOGIN */}
        <section>
          <h2 className="text-base font-semibold mb-3 flex items-center gap-2">
            <span className="text-[#4575A8] font-mono text-[10px] tracking-widest">03</span> Login screen (glass card)
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="space-y-2">
              <LoginA />
              <div className="text-[10px] uppercase tracking-widest text-[#4575A8]">★ PICK · A — Cinematic Stack</div>
              <div className="text-[11px] text-muted-foreground">120px stacked logo + ambient steel-blue glow behind it.</div>
            </div>
            <div className="space-y-2">
              <LoginB />
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">B — Minimalist Horizon</div>
              <div className="text-[11px] text-muted-foreground">36px wordmark, top-left of card. Editorial tech feel.</div>
            </div>
            <div className="space-y-2">
              <LoginC />
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">C — Hero Glyph (watermark)</div>
              <div className="text-[11px] text-muted-foreground">240px X at 6% opacity behind crisp HTML wordmark.</div>
            </div>
          </div>
        </section>

        <footer className="pt-6 border-t border-border text-[11px] text-muted-foreground">
          Recommended combo: <span className="text-[#4575A8]">Sidebar A · Tab C · Login A</span> — "Crisp & Cinematic"
          (HTML text for micro-surfaces · stacked PNG for the auth moment).
        </footer>
      </main>
    </div>
  );
}
